import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Callout } from '@fluentui/react/lib/Callout';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { Icon } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { getGuid } from 'owa-guid';
import loc from 'owa-localize';
import { attachmentPolicyInformationBlockedAccess } from 'owa-locstrings/lib/strings/attachmentpolicy.locstring.json';
import * as styles from './AttachmentBlockedCalloutButton.scss';

export default observer(function AttachmentBlockedCalloutButton() {
    const [isCalloutShown, setIsCalloutShown] = React.useState<boolean>(false);

    const toggleCallout = React.useCallback(
        e => {
            e.stopPropagation();
            setIsCalloutShown(!isCalloutShown);
        },
        [isCalloutShown]
    );

    const iconButtonId = 'calloutId' + getGuid();

    return (
        <>
            <Icon
                id={iconButtonId}
                iconName={ControlIcons.Info}
                className={styles.iconStyle}
                onClick={toggleCallout}
            />
            <Callout
                hidden={!isCalloutShown}
                className={styles.callout}
                onDismiss={toggleCallout}
                directionalHint={DirectionalHint.rightCenter}
                isBeakVisible={true}
                target={'#' + iconButtonId}>
                {loc(attachmentPolicyInformationBlockedAccess)}
            </Callout>
        </>
    );
});
